var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about-info-block"},[_c('img',{staticClass:"image",attrs:{"src":_vm.constituent.icon,"alt":""}}),_c('div',[_c('h6',{staticClass:"title"},[_vm._v(_vm._s(_vm.constituent.title))]),_c('p',{staticClass:"description"},[_vm._v(_vm._s(_vm.constituent.description))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }